import { maskCurrency, maskDate, maskUnd } from 'utils/mask';

export const dadosFormatados = (pedidos: any) => {
  const data = pedidos.map((elm: any) => {
    let status;
    switch (elm.status) {
      case 'SL':
        status = 'Solicitado';
        break;
      case 'AA':
        status = 'Aguardando agendamento';
        break;
      case 'AG':
        status = 'Agendado';
        break;
      case 'EM':
        status = 'Nota emitida';
        break;
      case 'EX':
        status = 'Expedido';
        break;
      default:
        status = '';
        break;
    }
    return {
      'N° da Solicitação': elm.nuNota,
      'N° do Pedido': elm.numNota,
      'N° da Nota': elm.nuNotaEmitida || 'Não informado',
      'Data Solicitação': maskDate(elm.dtSolicitacao),
      'Inscrição estadual': elm.inscricaoEstadualParceiro,
      Depositante: elm.parceiro,
      Pagador: elm.pagador,
      Parceiro: elm.parceiro,
      Status: status,
      'Peso Bruto': maskUnd(elm.peso) + ' KG',
      'Valor da Mercadoria': maskCurrency(elm.valor),
    };
  });

  return data;
};
